import { render } from "./PageReferanslar.vue?vue&type=template&id=52a54517&scoped=true"
import script from "./PageReferanslar.vue?vue&type=script&lang=js"
export * from "./PageReferanslar.vue?vue&type=script&lang=js"

import "./PageReferanslar.vue?vue&type=style&index=0&id=52a54517&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52a54517"

export default script